import styled from 'styled-components';
import { ReactComponent as LogoSvg } from '../dashboard/resources/logo.svg';
import { ReactComponent as LogoCompactSvg } from '../dashboard/resources/logoCompact.svg';
import { ReactComponent as LogoTransparentSvg } from '../dashboard/resources/logoTransapert.svg';

export const Logo = styled(LogoSvg).withConfig({ displayName: 'Logo' })`
    user-select: none;
    display: inline-block;
    fill: var(--color-primary);
    flex-shrink: 0;
    stroke: none;
    font-size: inherit;
    cursor: pointer;
`;

export const LogoCompact = styled(LogoCompactSvg).withConfig({ displayName: 'LogoCompact' })`
    user-select: none;
    display: inline-block;
    fill: var(--color-primary);
    flex-shrink: 0;
    stroke: none;
    font-size: inherit;
    cursor: pointer;
`;

export const LogoTransparent = styled(LogoTransparentSvg).withConfig({
    displayName: 'LogoTransparent',
})`
    user-select: none;
    display: inline-block;
    fill: var(--color-primary);
    flex-shrink: 0;
    stroke: none;
    font-size: inherit;
`;
